// sale invoices
const SaleIndex = () => import("./sale-invoices/index.vue");
const CreateSaleDocument = () => import("./sale-invoices/_pages/create.vue");
const SaleDocumentDetails = () => import("./sale-invoices/_pages/view.vue");

// proforma invoices
const ProformaIndex = () => import("./proforma-invoices/index.vue");
const CreateProformaDocument = () => import("./proforma-invoices/_pages/create.vue");
const ProformaDocumentDetails = () => import("./proforma-invoices/_pages/view.vue");

// quotations
const QuotationIndex = () => import("./quotations/index.vue");
const CreateQuotationDocument = () => import("./quotations/_pages/create.vue");
const QuotationDocumentDetails = () => import("./quotations/_pages/view.vue");

// sales order
const SalesOrderIndex = () => import("./sales-order/index.vue");
const CreateSalesOrderDocument = () => import("./sales-order/_pages/create.vue");
const SalesOrderDocumentDetails = () => import("./sales-order/_pages/view.vue");

// warehouse orders
const WarehouseOrdersIndex = () => import("./warehouse-orders/index.vue");
const CreateWarehouseOrder = () => import("./warehouse-orders/_pages/create.vue");
const WarehouseOrderDetails = () => import("./warehouse-orders/_pages/view.vue");

export default [
  {
    path: "/warehouse-orders",
    component: WarehouseOrdersIndex,
  },
  {
    path: "/new-warehouse-order",
    component: CreateWarehouseOrder,
  },
  {
    path: "/warehouse-order/:id",
    component: WarehouseOrderDetails,
  },
  {
    path: "/sale-invoices",
    component: SaleIndex,
  },
  {
    path: "/new-sale-invoice",
    component: CreateSaleDocument,
  },
  {
    path: "/sale-invoices/:id",
    component: SaleDocumentDetails,
  },
  {
    path: "/proforma-invoices",
    component: ProformaIndex,
  },
  {
    path: "/new-proforma-invoice",
    component: CreateProformaDocument,
  },
  {
    path: "/proforma-invoices/:id",
    component: ProformaDocumentDetails,
  },
  {
    path: "/sales-order",
    component: SalesOrderIndex,
  },
  {
    path: "/new-sales-order",
    component: CreateSalesOrderDocument,
  },
  {
    path: "/sales-order/:id",
    component: SalesOrderDocumentDetails,
  },
  {
    path: "/quotations",
    component: QuotationIndex,
  },
  {
    path: "/new-quotation",
    component: CreateQuotationDocument,
  },
  {
    path: "/quotations/:id",
    component: QuotationDocumentDetails,
  },
];
